import React from "react";
import { Link } from "react-router-dom";
import { useLang } from "@/lib/lang";

/**
 * Landing footer with tagline, sitemap, contacts, partner portals and legal links.
 */
export default function LandingFooter({ onScrollTo }) {
  const { t } = useLang();
  return (
    <footer className="dt-footer" data-testid="landing-footer">
      <div className="dt-footer__inner">
        <div>
          <div className="dt-header__logo" style={{ fontSize: "1.6rem" }}>
            DI<span className="g">TOURS</span>
          </div>
          <p className="dt-footer__tagline">{t("landing_footer_tagline")}</p>
        </div>
        <div>
          <p className="dt-footer__title">{t("landing_footer_company")}</p>
          <button type="button" onClick={() => onScrollTo("how")} className="dt-footer__link">
            {t("landing_footer_link_how")}
          </button>
          <button type="button" onClick={() => onScrollTo("tours")} className="dt-footer__link">
            {t("landing_footer_link_tours")}
          </button>
          <button type="button" onClick={() => onScrollTo("transfers")} className="dt-footer__link">
            {t("landing_footer_link_transfers")}
          </button>
        </div>
        <div>
          <p className="dt-footer__title">{t("landing_footer_contacts")}</p>
          <a href="mailto:reservas@ditours.pt" className="dt-footer__link">reservas@ditours.pt</a>
          <a href="tel:+351911234567" className="dt-footer__link">+351 911 234 567</a>
        </div>
        <div>
          <p className="dt-footer__title">{t("landing_footer_partnerships")}</p>
          <button type="button" onClick={() => onScrollTo("join")} className="dt-footer__link">
            {t("landing_footer_join")}
          </button>
          <Link to="/login" className="dt-footer__link" data-testid="footer-login-partner">
            🏨 {t("landing_footer_partner_portal")}
          </Link>
          <Link to="/login" className="dt-footer__link" data-testid="footer-login-driver">
            🚗 {t("landing_footer_driver_portal")}
          </Link>
          <Link to="/login" className="dt-footer__link" data-testid="footer-login-fleet">
            🚙 {t("landing_footer_fleet_portal")}
          </Link>
          <Link
            to="/login"
            className="dt-footer__link"
            data-testid="footer-login-admin"
            style={{ opacity: 0.7, fontSize: "0.78rem" }}
          >
            {t("landing_footer_admin_area")}
          </Link>
        </div>
        <div>
          <p className="dt-footer__title">{t("landing_footer_legal")}</p>
          <Link to="/termos" className="dt-footer__link">{t("landing_footer_terms")}</Link>
          <Link to="/privacidade" className="dt-footer__link">{t("landing_footer_privacy")}</Link>
          <Link to="/cookies" className="dt-footer__link">{t("landing_footer_cookies")}</Link>
          <Link to="/reclamacoes" className="dt-footer__link" data-testid="footer-reclamacoes">
            {t("landing_footer_complaints")}
          </Link>
        </div>
      </div>
      <div className="dt-footer__bottom">
        © {new Date().getFullYear()} DiTours · {t("landing_footer_made_with")} ·{" "}
        <Link to="/login" style={{ color: "inherit" }}>{t("landing_footer_private_area")}</Link>
      </div>
    </footer>
  );
}
